var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSplitPieChart = function SvgSplitPieChart(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBF0F3",
    d: "M65.62 16.639l-23.325 33.55-1.532-.834L27.19 12.166l.6-1.719c4.523-1.653 9.41-2.553 14.505-2.553 8.457 0 16.332 2.485 22.942 6.76.666.43.836 1.332.383 1.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#27A2DB",
    d: "M42.294 50.19l-1.032 1.529L4.026 63.608l-2.032-.551C.699 58.998 0 54.677 0 50.189c0-18.241 11.548-33.785 27.731-39.72l.058-.02 14.505 39.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64798A",
    d: "M83.156 50.19c.792 0 1.436.653 1.41 1.445-.763 22.69-19.396 40.849-42.271 40.849-18.872 0-34.857-12.36-40.3-29.427l40.3-12.867h40.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCD462",
    d: "M81.053 8.12L59.268 39.454c-.65.935.02 2.215 1.158 2.215H98.59c.793 0 1.437-.655 1.41-1.448-.446-13.262-7-24.974-16.934-32.418-.643-.482-1.554-.342-2.012.317z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H100V100H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSplitPieChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/split_pie_chart.e20eacb3.svg";
export { ForwardRef as ReactComponent };